import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { EMarkAllAsReadNotificationActionTypes, TMarkAllAsReadNotificationLoading } from './types';

export const markAllAsReadLoading: () => TMarkAllAsReadNotificationLoading =
  actionGenerator<EMarkAllAsReadNotificationActionTypes.Loading>(EMarkAllAsReadNotificationActionTypes.Loading);
